import ajax from '@/helpers/ajax'

async function fetchNextPageOfComments({ state, commit }) {
  const {data: { comments }, meta: { currentPage, nextPage}} = await fetchPageOfComments(state.petitionSlug, state.currentPage + 1)
  commit('appendComments', { comments, currentPage, nextPage })
}

function flagComment({ state, commit }, { commentId, friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken }) {
  const payload = {}

  if (friendlyCaptchaSolution) {
    payload.friendly_captcha_solution = friendlyCaptchaSolution
  }
  if (hcaptchaResponse) {
    payload.hcaptcha_response = hcaptchaResponse
  }
  if (recaptchaToken) {
    payload.recaptcha_token = recaptchaToken
  }
  if (turnstileToken) {
    payload.turnstile_token = turnstileToken
  }

  return new Promise((resolve, reject) => {
    ajax.post({
      url: petitionCommentFlagPath(state.petitionSlug, commentId),
      data: payload,
      successHandler: () => {
        fetchPageOfComments(state.petitionSlug, 1)
          .then(({ data: { comments }, meta: { currentPage, nextPage} }) => {
            commit('initializeComments', { comments, currentPage, nextPage })
          })
          .then(() => {
            resolve()
          })
      },
      errorHandler: (err) => {
        reject(err)
      }
    })
  })
}

// Helpers

function fetchPageOfComments(petitionSlug, page) {
  return new Promise((resolve, reject) => {
    ajax.get({
      url: petitionCommentsPath(petitionSlug),
      params: { page },
      successHandler: (response) => {
        resolve(response)
      },
      errorHandler: (err) => {
        reject(err)
      }
    })
  })
}

function petitionCommentsPath(petitionSlug) {
  return `/petitions/${petitionSlug}/comments`
}

function petitionCommentFlagPath(petitionSlug, commentId) {
  return `/petitions/${petitionSlug}/comments/${commentId}/flags`
}

export default {
  fetchNextPageOfComments,
  flagComment
}
